"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEntrypoint = exports.Entrypoint = exports.authenticate = void 0;
const client_1 = require("./client");
const telekinesis_1 = require("./telekinesis");
function authenticate(urlOrEntrypoint = 'ws://localhost:8776', sessionKey, printCallback = console.log, kwargs) {
    return __awaiter(this, void 0, void 0, function* () {
        let entrypoint;
        if (typeof urlOrEntrypoint === 'string') {
            entrypoint = new Entrypoint(urlOrEntrypoint, sessionKey);
        }
        else {
            entrypoint = urlOrEntrypoint;
        }
        let pubkeyWasChecked = false;
        function printCallbackWrapper(...args) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!pubkeyWasChecked) {
                    if (args[0] !== (yield entrypoint._session.sessionKey.publicSerial())) {
                        throw new telekinesis_1.PermissionError("Public keys don't match");
                    }
                    pubkeyWasChecked = true;
                    if (!printCallback) {
                        return;
                    }
                    args = ["Your session public key is:\n" + args[0], ...args.slice(1)];
                }
                yield printCallback.apply(null, args);
                return printCallback;
            });
        }
        let user = yield entrypoint.authenticate._call([printCallbackWrapper], kwargs);
        if (!pubkeyWasChecked) {
            throw new telekinesis_1.PermissionError('Session Public Key was never checked');
        }
        return user;
    });
}
exports.authenticate = authenticate;
class Entrypoint {
    constructor(url = 'ws://localhost:8776', sessionKey, ...args) {
        if (!/(?![\w\d]+:\/\/[\w\d.]+):[\d]+/.exec(url)) {
            let i = /[\w\d]+:\/\/[\w\d.]+/.exec(url)[0].length;
            url = url.slice(0, i) + ':8776' + url.slice(i);
        }
        const session = new client_1.Session(sessionKey);
        const connection = new client_1.Connection(session, url);
        return new telekinesis_1.Telekinesis(new Promise((r) => connection.connect().then(() => r(connection.entrypoint))), session, ...args);
    }
    get() { }
}
exports.Entrypoint = Entrypoint;
function createEntrypoint(target, url = 'ws://localhost:8776', sessionKey, channelKey, isPublic = true, ...args) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!/(?![\w\d]+:\/\/[\w\d.]+):[\d]+/.exec(url)) {
            let i = /[\w\d]+:\/\/[\w\d.]+/.exec(url)[0].length;
            url = url.slice(0, i) + ':8776' + url.slice(i);
        }
        const session = new client_1.Session(sessionKey);
        const connection = new client_1.Connection(session, url);
        yield connection.connect();
        const tk = new telekinesis_1.Telekinesis(target, session, ...args);
        tk._channel = new client_1.Channel(session, channelKey, isPublic);
        tk._channel.listen();
        tk._channel.telekinesis = tk;
        yield tk._channel.execute();
        return tk._channel.route, tk;
    });
}
exports.createEntrypoint = createEntrypoint;
//# sourceMappingURL=helpers.js.map